module.exports = __webpack_public_path__ + "static/media/toggle-close.a0150db2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/toggle-close.svg
// module id = 656
// module chunks = 0